<section class="av-card p-4 d-flex flex-column gap-3">
  <div class="d-flex flex-wrap align-items-start justify-content-between gap-3">
    <div class="d-flex flex-column gap-1">
      <h2 class="av-section-title m-0">{{ 'backoffice.organizations.list.title' | translate }}</h2>
      <p class="av-meta m-0">{{ 'backoffice.organizations.list.scope_note' | translate }}</p>
    </div>

    <div class="d-flex align-items-center gap-2">
      <button type="button" class="av-btn" [disabled]="facade.isBusy()" (click)="facade.reload()">
        <mat-icon aria-hidden="true">refresh</mat-icon>
        {{ 'backoffice.common.actions.refresh' | translate }}
      </button>

      <button
        type="button"
        class="av-btn av-btn-primary"
        [disabled]="facade.isExporting()"
        [matTooltip]="'backoffice.organizations.list.export_note' | translate"
        (click)="exportCsv()"
      >
        <mat-icon aria-hidden="true">download</mat-icon>
        {{ 'backoffice.common.actions.export_csv' | translate }}
      </button>
    </div>
  </div>

  <av-organization-filters
    [value]="facade.filters()"
    [plans]="facade.planOptions()"
    [disabled]="facade.isBusy()"
    (filtersChange)="applyFilters($event)"
    (resetFilters)="clearFilters()"
  ></av-organization-filters>
</section>

<section class="av-card p-4 mt-3 d-flex flex-column">
  @switch (facade.state()) {
    @case ('error') {
      <av-empty-state
        icon="error_outline"
        [title]="'backoffice.organizations.list.error.title' | translate"
        [message]="'backoffice.organizations.list.error.message' | translate"
      ></av-empty-state>
    }
    @case ('ready') {
      @if (facade.isEmpty()) {
        <av-empty-state
          icon="corporate_fare"
          [title]="emptyTitleKey() | translate"
          [message]="emptyMessageKey() | translate"
        ></av-empty-state>
      } @else {
        <div class="table-scroll">
          <table class="av-table w-100">
            <thead>
              <tr>
                <th scope="col">{{ 'backoffice.organizations.list.columns.organization' | translate }}</th>
                <th scope="col">{{ 'backoffice.organizations.list.columns.status' | translate }}</th>
                <th scope="col">{{ 'backoffice.organizations.list.columns.plan' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.organizations.list.columns.mrr' | translate }}</th>
                <th scope="col">{{ 'backoffice.organizations.list.columns.payment_health' | translate }}</th>
                <th scope="col">{{ 'backoffice.organizations.list.columns.tenant' | translate }}</th>
                <th scope="col">{{ 'backoffice.organizations.list.columns.created' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.organizations.list.columns.actions' | translate }}</th>
              </tr>
            </thead>

            <tbody>
              @for (organization of facade.organizations(); track organization.id) {
                <tr>
                  <td>
                    <div class="d-flex flex-column">
                      <span class="cell-strong">{{ organization.displayName }}</span>
                      <span class="av-meta">{{ organization.domain || unresolved }}</span>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex align-items-center gap-2">
                      <av-status-chip
                        [label]="organization.statusLabelKey | translate"
                        [tone]="organization.statusTone"
                      ></av-status-chip>

                      @if (organization.rootIsMissing) {
                        <av-status-chip
                          [label]="'backoffice.common.root_missing' | translate"
                          tone="danger"
                        ></av-status-chip>
                      }
                    </div>
                  </td>

                  <td class="cell-muted">{{ organization.plan_name || unresolved }}</td>

                  <td class="text-end">
                    {{ organization.mrr | number: '1.2-2' }}
                    {{ organization.billing_currency || unresolved }}
                  </td>

                  <td>
                    <av-status-chip
                      [label]="organization.healthLabelKey | translate"
                      [tone]="organization.healthTone"
                    ></av-status-chip>
                  </td>

                  <td class="cell-muted tenant-cell">
                    {{ organization.entra_tenant_id || unresolved }}
                  </td>

                  <td class="cell-muted">
                    {{
                      organization.created_at
                        ? (organization.created_at | date: dateFormat)
                        : unresolved
                    }}
                  </td>

                  <td class="text-end">
                    <div class="d-flex justify-content-end gap-1">
                      <button
                        type="button"
                        class="av-btn av-btn-primary"
                        data-testid="organization-open"
                        [matTooltip]="'backoffice.organizations.list.detail_action_note' | translate"
                        (click)="openDetail(organization)"
                      >
                        <mat-icon aria-hidden="true">open_in_new</mat-icon>
                        {{ 'backoffice.common.actions.open' | translate }}
                      </button>

                      <button
                        type="button"
                        class="av-btn"
                        [matTooltip]="'backoffice.organizations.list.people_action_note' | translate"
                        (click)="openPeople(organization)"
                      >
                        <mat-icon aria-hidden="true">group</mat-icon>
                        {{ 'backoffice.organizations.list.people' | translate }}
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <av-paginator
          [page]="facade.page()"
          [pageSize]="facade.pageSize()"
          [total]="facade.total()"
          [disabled]="facade.isBusy()"
          (pageChange)="goToPage($event)"
          (pageSizeChange)="changePageSize($event)"
        ></av-paginator>
      }
    }
    @default {
      <av-empty-state
        icon="hourglass_empty"
        [title]="'backoffice.organizations.list.loading.title' | translate"
        [message]="'backoffice.organizations.list.loading.message' | translate"
      ></av-empty-state>
    }
  }
</section>
